import { useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ProformaIntakeClient } from "@/features/proformas/ProformaIntakeClient";
import { useBreadcrumbContext } from "@/components/shell/BreadcrumbContext";

export const Route = createFileRoute("/_shell/proformas/new")({
  component: NewProformaPage,
});

function NewProformaPage() {
  const { t } = useTranslation();
  const { setDetail } = useBreadcrumbContext();

  useEffect(() => {
    setDetail(t("proforma.new"));
    return () => setDetail(null);
  }, [t, setDetail]);

  return <ProformaIntakeClient />;
}
